import { render } from "./DashboardOrbit.vue?vue&type=template&id=62f07fda&scoped=true&ts=true"
import script from "./DashboardOrbit.vue?vue&type=script&lang=ts"
export * from "./DashboardOrbit.vue?vue&type=script&lang=ts"

import "./DashboardOrbit.vue?vue&type=style&index=0&id=62f07fda&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f07fda"]])

export default __exports__